import { styled } from '@volkswagen-onehub/components-core';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SelectExtended } from 'src/components';
import { useIsComerciales } from 'src/feature-app';
import { useOneFormContext } from 'src/feature-app/OneForm';
import { OneFormState } from 'src/types';

const InputsWrapper = styled.div`
	padding-top: 44px;
	width: 100%;
	@media all and (min-width: 560px) {
		width: 303px;
	}
	@media all and (min-width: 960px) {
		width: 320px;
	}
`;

export const motivoOptions = [
	{
		code: 'VE',
		name: 'Venta',
	},
	{
		code: 'PV',
		name: 'Posventa',
	},
	{
		code: 'GDP',
		name: 'Gestión de datos personales y privacidad',
	},
	{
		code: 'OT',
		name: 'Otras consultas',
	},
];

const motivoOptionsComerciales = [
	{
		code: 'Consulta',
		name: 'Consulta',
	},
	{
		code: 'Modificación de datos',
		name: 'Modificación de datos',
	},
	{
		code: 'Reclamación',
		name: 'Reclamación',
	},
	{
		code: 'Solicitud',
		name: 'Solicitud',
	},
	{
		code: 'Sugerencia',
		name: 'Sugerencia',
	},
	{
		code: 'No quiero recibir más comunicaciones comerciales',
		name: 'No quiero recibir más comunicaciones comerciales',
	},
	{
		code: 'Consulta sobre protección de datos',
		name: 'Consulta sobre protección de datos',
	},
	{
		code: 'Otros',
		name: 'Otros',
	},
];

export const PantallaMotivoSAC = () => {
	const [motivo, setMotivo] = useState(null);
	const { fields } = useSelector((state: OneFormState) => state.formData);
	const dispatch = useDispatch();
	const { handleNextStep } = useOneFormContext();
	const isComerciales = useIsComerciales();

	useEffect(() => {
		if (fields.motivoSac) {
			const m = getMotivoByCode(fields.motivoSac);
			setMotivo(m);
		}
	}, []);

	const getMotivoByName = name => {
		if (isComerciales) {
			return motivoOptionsComerciales
				? motivoOptionsComerciales.find(obj => obj.name == name)
				: null;
		}
		return motivoOptions
			? motivoOptions.find(obj => obj.name == name)
			: null;
	};

	const getMotivoByCode = code => {
		if (isComerciales) {
			return motivoOptionsComerciales
				? motivoOptionsComerciales.find(obj => obj.code == code)
				: null;
		}
		return motivoOptions
			? motivoOptions.find(obj => obj.code == code)
			: null;
	};

	function handleChangeMotivo(e: any) {
		e.preventDefault();
		if (e.target.value) {
			const m = getMotivoByName(e.target.value);
			setMotivo(m);
			dispatch({
				type: 'UPDATE_FIELDS',
				payload: { ['motivoSac']: m.code },
			});
			dispatch({
				type: 'UPDATE_LITERAL_FIELDS_STEPS',
				payload: { ['motivoSac']: m.name },
			});
			handleNextStep();
		}
	}

	return (
		<>
			<InputsWrapper>
				<SelectExtended
					options={
						isComerciales ? motivoOptionsComerciales : motivoOptions
					}
					name="motivoSac"
					label="Elige un motivo"
					isRequired
					isFloating
					value={motivo ? motivo.name : ''}
					onClick={() => null}
					setOption={setMotivo}
					handleChange={handleChangeMotivo}
				/>
			</InputsWrapper>
		</>
	);
};
